import React, { useMemo } from 'react';
import { transport } from '@mrkt/features/Platform';
import {
  RemoteConfigProvider,
  createResolver,
} from '@mrkt/features/RemoteConfig';
import { useCurrentUser } from '../features/currentUser';

type Props = {
  children: React.ReactNode;
};

function RemoteConfigResolver({ children }: Props) {
  const userKey = useCurrentUser()?.username;

  const value = useMemo(() => {
    const resolver = createResolver({ transport });
    resolver.resolve({ userKey });
    return resolver;
  }, [userKey]);

  return <RemoteConfigProvider value={value}>{children}</RemoteConfigProvider>;
}

export function RemoteConfig(props: Props) {
  // needed for now to get tests working until we figure out transport in tests
  if (process.env.NODE_ENV === 'test') {
    return <>{props.children}</>;
  }

  return <RemoteConfigResolver {...props} />;
}
